<!--
	  @修改人：黎柏祺
    @修改时间：2018-10-24
    @修改描述：框架升级
    @版本:v1.0.26
    --------
	  @负责人: 谢汉
    @创建时间: 2018-07-25
    @版本:v1.0.19
    @描述: 主机地图模块信息详情页
    -->
<template>
  <div class="hostMonitorModuleDetail__content">
    <back :history="history"></back>
    <el-tabs type="border-card"  v-model="activeName" @tab-click="tab_change">
      <el-tab-pane :label="$t('hostMapping.baseInfo')" name="first">
        <div class="moduleInfo">
          <div class="mb-base">
            <span v-text="$t('hostMapping.machineType') + '：' + machineType" class="mr50 lock-width"></span>
            <span v-text="$t('hostMapping.module') + '：' + moduleName"></span>
          </div>
          <div>
            <span v-text="$t('hostMapping.applications') + '：' + applications"></span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('hostMapping.hostPerformance')" name="second">
        <div class="hostMonitorModuleDetail__form" >
            <el-form ref="form" :inline="true" label-width="150" input-width="auto">
              <el-form-item>
                  <el-button type="primary"  v-text="$t('hostMapping.today')" @click="e_getHostTime(1)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
                  <el-button type="primary"  v-text="$t('hostMapping.thirtyMins')" @click="e_getHostTime(1800000)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
                  <el-button type="primary"  v-text="$t('hostMapping.oneHour')" @click="e_getHostTime(3600000)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
                  <el-button type="primary"  v-text="$t('hostMapping.threeHours')" @click="e_getHostTime(10800000)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
                  <el-button type="primary"  v-text="$t('hostMapping.sixHours')" @click="e_getHostTime(21600000)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
                  <el-button type="primary"  v-text="$t('hostMapping.yesterday')" @click="e_getHostTime(2)" v-g-rac="gRac('hostMappingModuleDetail@search')"></el-button>
              </el-form-item>
              <el-form-item :label="$t('hostMapping.startTime')">
                <el-date-picker
                  v-model="form.startTime"
                  type="datetime"
                  value-format="timestamp">
                </el-date-picker>
                {{$t('hostMapping.to')}}
                <el-date-picker
                  v-model="form.endTime"
                  type="datetime"
                  value-format="timestamp">
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('hostMapping.ip')">
                <el-input disabled v-model="form.ip"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="login-btn" @click="e_searchHostChart" v-g-rac="gRac('hostMappingModuleDetail@search')">{{ $t('common.search') }}</el-button>
              </el-form-item>
            </el-form>      
        </div>
        <chart-config-list v-show="hostChartData.length !== 0" :chart-data-list="hostChartData" @chart-conf-click="toAlarmStrategy"></chart-config-list>
        <div v-show="hostChartData.length === 0"  v-text="$t('common.noData')" style="text-align: center"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/javascript">
  import back from '@/components/back.vue'
  import chartConfigList from '@/components/chart/chart-config-list.vue'
  import HostMappingBiz from '@/logic/intelligentMonitor/hostMappingBiz.js'
  import rac from '@/plugins/rac-mixin.js'
  import appDetailBiz from '@/logic/intelligentMonitor/appDetailBiz.js'
  import TimeFormat from '@/utils/timeFormat.js'
  import AlarmStrategyBiz from '@/logic/systemSetting/alarmStrategyBiz.js'
  import tab from '@/views/layout/components/setTab'

  export default {
    mixins: [rac],
    components: {
      back,
      chartConfigList
    },
    data () {
      return {
        activeName: 'first',
        history: [],
        form: {
          startTime: '',
          endTime: '',
          ip: ''
        },
        siteCode: '',
        applications: '',
        moduleName: '',
        department: '',
        hostChartData: [],
        hostFields: [],
        machineType: '',
        initFlag: true
      }
    },
    watch: {
      '$route' (newValue, oldValue) {
        if (newValue.name === 'hostMappingModuleDetail' && oldValue.name === 'hostMappingModule') {
          this.initFlag = true
          this.activeName = 'first'
          this.e_init()
        }
      }
    },
    methods: {
      e_reset () {
        this.applications = ''
        this.clickId = ''
        this.hostFields = []
      },
      e_getModuleInfo () {
        this.e_reset()
        this.activeName = 'first'
        HostMappingBiz.getModule({
          department: this.department,
          siteCode: this.siteCode
        }).then((data) => {
          this.moduleName = data.moduleName
          this.totalHostNum = data.total
          data.hostInfo.map((item) => {
            if (item.ip1 === this.form.ip) {
              this.machineType = item.instanceType
              this.applications = ''
              if (item.applications && item.applications.length > 0) {
                item.applications.map((app, index) => {
                  let str = index !== item.applications.length - 1 ? app + '、' : app
                  this.applications += str
                })
              } else {
                this.applications = this.$t('hostMapping.none')
              }
            }
          })
          this.setHistory(data.siteName)
        })
      },
      setHistory (siteName) {
        if (siteName) {
          this.history.splice(0, 1, {
            name: siteName,
            path: `/home/hostMapping/hostMappingDetail?siteCode=${this.siteCode}`
          })
          this.history.splice(1, 1, {
            name: this.department,
            path: `/home/hostMapping/hostMappingModule?siteCode=${this.siteCode}&department=${this.department}`
          })
          this.history.splice(2, 1, { name: this.form.ip })
        } else {
          this.history = []
          this.history.push({ name: 'null' })
          this.history.push({ name: this.department })
          this.history.push({ name: this.form.ip })
        }
      },
      tab_change (e) {
        if (e.name === 'second' && this.initFlag) {
          this.e_getHostKpiMap()
          this.initFlag = false
        }
      },
      e_getHostTime (time) {
        if (time === 1) {
          this.form.startTime = TimeFormat.getToday()
          this.form.endTime = new Date().getTime()
        } else if (time === 2) {
          this.form.startTime = TimeFormat.getDayNearToday(-1)
          this.form.endTime = TimeFormat.getToday()
        } else {
          this.form.startTime = new Date().getTime() - time
          this.form.endTime = new Date().getTime()
        }
        this.e_getHostKpiMap()
      },
      e_getHostKpiMap () {
        appDetailBiz.getHostKpiMapData(this.$route.query.siteCode).then((data) => {
          let promiseList = []
          let promiseRes = []
          this.hostFields = data
          data.map(item => {
            let searchData = {
              startTime: parseInt(this.form.startTime / 1000),
              endTime: this.form.endTime === '' ? parseInt(new Date().getTime() / 1000) : parseInt(this.form.endTime / 1000),
              ip: this.form.ip,
              kpiKey: item.kpiKey,
              appName: item.appName,
              siteCode: item.siteCode
            }
            promiseList.push(this.getChartData(searchData, item.desc, item.fields[0].format))
          })
          Promise.all(promiseList).then((res) => {
            res.map(_item => {
              promiseRes.push(_item)
            })
            this.drawChart(promiseRes)
          })
        })
      },
      e_searchHostChart () {
        this.e_getHostKpiMap()
      },
      getChartData (searchData, desc, format) {
        return new Promise((resolve, reject) => {
          HostMappingBiz.searchChartData(searchData).then((data) => {
            resolve({ title: desc, data: data.performs, format: format, siteCode: data.siteCode })
          }).catch(err => {
            reject(err)
          })
        })
      },
      drawChart (dataList) {
        const list = []
        dataList.map((item, index) => {
          const chartData = {
            title: item.title,
            chartId: `${item.title}-${index}`,
            chartData: {
              rows: item.data ? item.data : [],
              columns: ['time', 'value'],
              formatMap: {
                time: 'TIME',
                value: item.format
              },
              labelMap: {
                value: item.title
              }
            }
          }
          list.push(chartData)
        })
        this.hostChartData = list
      },
      initTime () {
        this.form.startTime = TimeFormat.getToday()
      },
      e_init () {
        this.hostChartData = []
        this.siteCode = this.$route.query.siteCode
        this.department = this.$route.query.department
        this.form.ip = this.$route.query.ip
        this.initTime()
        this.setHistory()
        this.e_getModuleInfo()
      },
      toAlarmStrategy (data) {
        let searchData = {}
        this.hostFields.forEach((item) => {
          if (item.desc === data.data.title) {
            searchData = {
              group: item.group,
              kpiKey: item.kpiKey,
              appName: item.appName,
              siteCode: item.siteCode
            }
          }
        })
        AlarmStrategyBiz.findAlarmStrategyId(searchData).then((data) => {
          let strategyInfo = data
          if (strategyInfo.length > 0 && strategyInfo[0].alarmCode) {
            this.$router.push({ path: `/home/alarmStrategy/editStrategy?alarmCode=${strategyInfo[0].alarmCode}` })
            tab.selectTab('alarmStrategy')
          } else {
            this.$router.push({ path: `/home/alarmStrategy/addStrategy?appName=${searchData.appName}&appGroup=${searchData.group}&kpiKey=${searchData.kpiKey}&sourceType=1` })
            tab.selectTab('alarmStrategy')
          }
        })
      }
    },
    mounted () {
      this.e_init()
    }
  }
</script>
<style scoped>
    .hostMonitorModuleDetail__content {
      font-size: 14px;
    }
    .hostMonitorModuleDetail__content .mr50{
      margin-right: 50px;
    }
    .hostMonitorModuleDetail__content .moduleInfo {
        padding: 18px;
    }
    .hostMonitorModuleDetail__content .lock-width {
        display: inline-block;
        width: 200px;
    }
</style>